module.exports = __webpack_public_path__ + "static/media/Apple iPhone SE Space Gray.746349e2.png";